/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `LockIconProps` interface defines the properties for the LockIcon component.
 */
interface LockIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "lock" — outlined, weight 300.
 * Lock icon for locked waypoints.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const LockIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'LockIcon',
    width
}: LockIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-60h480q8 0 14-6t6-14v-400q0-8-6-14t-14-6H240q-8 0-14 6t-6 14v400q0 8 6 14t14 6Zm240-140q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM220-140v-460 460Z" />
    </svg>
);

LockIcon.displayName = 'LockIcon';